import React from 'react';
import { Box, Typography } from '@mui/material';
import useStyles from '../styles';
import Steps from './Steps';

interface HeaderProps {
  currentStep: number;
  totalSteps: number;
}

function Header({ currentStep, totalSteps }: HeaderProps) {
  const classes = useStyles();

  return (
    <Box className={classes.headerContainer}>
      <Box className={classes.headerContent}>
        <Typography className={classes.mainTitle}>
          Formulario de Inscripción
        </Typography>
        <Box>
          <Typography
            color='textPrimary'
            className={classes.subtitle}
          >
            Completa la información del siguiente formulario y
            luego te enviaremos la propuesta de estudios.
          </Typography>
        </Box>
      </Box>
      <Steps currentStep={currentStep} totalSteps={totalSteps} />
    </Box>
  );
}

export default Header;
